module.exports = {
	"nl": {
		"conversation": {
			"widget": {
				"title": "Chat met ons",
				"subtitle": ""
			}
		}
	}
};